/** ONCE MIGRATION OF ALL COMPONENTS, SERVICES, DIRECTIVES ARE COMPLETED,
 * THIS FILE HAVE TO CHANGE TO MODULE WITH LOADING RESPECTIVE COMPONENTS
 */

export const integrationsViewController = {
    selector: 'integrationsViewController',
    bindings: {},
    template: '<app-integrations-view></app-integrations-view>'
}